import { globalApi as api } from '../../api';

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

const serviceParams = (service) => (service ? { params: { service } } : {});

export const fetchNotifications = async (service) => {
  const response = await api.get('/get_notifications', serviceParams(service));
  return response.data;
};

export const fetchNotificationUnreadCount = async (service) => {
  const response = await api.get('/get_notifications/unread_count', serviceParams(service));
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await api.put(`/notifications/${id}/read`);
  return response.data;
};

export const markAllNotificationsRead = async (service) => {
  const response = await api.put('/notifications/read_all', null, serviceParams(service));
  return response.data;
};
